export default __webpack_public_path__ + "static/media/pump.42f0ee27.svg";